module.exports = __webpack_public_path__ + "static/img/1-1.fc36dde.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/8/eng/1-1.png
// module id = 8EZI
// module chunks = 0